import AllInclusiveIcon from "@mui/icons-material/AllInclusive";

interface UnlimitedLabelProps {
  /** Icon size in px. Defaults to 16 to sit inline with body text. */
  iconSize?: number;
}

/**
 * Inline "∞ Unlimited" label used wherever an unlimited plan limit is shown.
 * Renders as a fragment so it can live inside a Typography/text run without
 * producing invalid nested block elements.
 */
const UnlimitedLabel = ({ iconSize = 16 }: UnlimitedLabelProps) => (
  <>
    <AllInclusiveIcon
      sx={{ fontSize: iconSize, verticalAlign: "text-bottom", mr: 0.5 }}
    />
    Unlimited
  </>
);

export default UnlimitedLabel;
